export default "__VITE_ASSET__B81KrLTO__"